var React = require('react');

function IcRightComponent (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"<","fillRule":"evenodd","clipRule":"evenodd","d":"M9.50001 8C9.50001 7.73438 9.39064 7.48438 9.20314 7.29688L2.20313 0.296875C2.01563 0.109375 1.76563 0 1.5 0C0.953126 0 0.5 0.453125 0.5 1V15C0.5 15.5469 0.953126 16 1.5 16C1.76563 16 2.01563 15.8906 2.20313 15.7031L9.20314 8.70312C9.39064 8.51562 9.50001 8.26562 9.50001 8Z","fill":"#9C9C9C"}));
}

IcRightComponent.defaultProps = {"width":"10","height":"16","viewBox":"0 0 10 16","fill":"none"};

module.exports = IcRightComponent;

IcRightComponent.default = IcRightComponent;



//////////////////
// WEBPACK FOOTER
// ./src/components/PaginationV2/ic-right.component.svg
// module id = 1644
// module chunks = 0